export const plantTooltipTextsByState = {
  different_solution: "Different Solution in Place",
  possible_replication: "Possible Replication",
  under_review: "Under Review",
  not_applicable: "Not Applicable for this Plant",
  original: "Original",
  replicated: "Replicated",
};
